import React from 'react';
import cn from 'classnames';
import styles from './Card.module.scss';
import { ReactComponent as CardBgIcon } from '../../images/card_bg.svg';
import { AB_CARDS_3_4_CLASS } from '../../constants';
import { useLocalStorage } from '../../hooks';

type Props = {
  title: string;
  date: string;
  description: string;
  list: string[];
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  bgColor: string;
  color: string;
  onValidationOpen(): void;
  onSendEvent: () => void;
};

export function Card({
  title,
  date,
  description,
  list,
  icon,
  color,
  bgColor,
  onValidationOpen,
  onSendEvent,
}: Props) {
  const [seenSorry] = useLocalStorage('seenSorry', false);

  const Icon = icon;
  return (
    <div className={styles.root}>
      <div
        className={cn(
          styles.upperWrapper,
          title === AB_CARDS_3_4_CLASS[5].title && styles.upperWrapper_small,
        )}
      >
        <div className={styles.cardBg} style={{ background: bgColor, color }}>
          <CardBgIcon />
        </div>
        <Icon className={styles.icon} />
        <p className={styles.cardTag}>прямой эфир</p>
        <p
          className={cn(
            styles.cardTitle,
            title === AB_CARDS_3_4_CLASS[5].title && styles.cardTitle_small,
          )}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div className={styles.date} dangerouslySetInnerHTML={{ __html: date }} />
      </div>
      <div className={styles.content}>
        <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
        <ul className={styles.list}>
          {list.map((item) => (
            <li key={item} dangerouslySetInnerHTML={{ __html: item }} />
          ))}
        </ul>
      </div>

      {!seenSorry && (
        <button
          type="button"
          className={styles.button}
          onClick={() => {
            onSendEvent();
            onValidationOpen();
          }}
        >
          <div className={styles.border} />
          Оформить доступ
        </button>
      )}
    </div>
  );
}
